const EMPTY_FORM = {
  name: "", email: "", phoneDial: "+91", phone: "", organisation: "", jobTitle: "",
  targetRole: "", expertise: "", experience: "", location: "", portfolio: "",
  preferredContact: "email", consent: false, message: "",
};

export function createJourney(initialPath = null) {
  return { step: initialPath ? "questions" : "select", pathId: initialPath || null,
    answers: {}, qIndex: 0, form: { ...EMPTY_FORM }, errors: {}, submitting: false };
}

function toggleAnswer(current, value) {
  const values = Array.isArray(current) ? current : [];
  return values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
}

export function journeyReducer(state, action) {
  switch (action.type) {
    case "reset": return createJourney(action.initialPath);
    case "choose": return { ...state, pathId: action.pathId, answers: {}, qIndex: 0, step: "questions" };
    case "answer": return { ...state, answers: { ...state.answers, [action.id]: action.value } };
    case "multi": return { ...state, answers: { ...state.answers,
      [action.id]: toggleAnswer(state.answers[action.id], action.value) } };
    case "field": return { ...state, form: { ...state.form, [action.field]: action.value } };
    case "patch": return { ...state, ...action.values };
    default: return state;
  }
}

export function canAdvanceQuestion(question, answers) {
  if (!question || question.optional) return true;
  const value = answers[question.id];
  if (question.type === "multi") return Array.isArray(value) && value.length > 0;
  return value != null && value !== "";
}

function summaryAnswer(question, value) {
  if (value == null || value === "" || (Array.isArray(value) && value.length === 0)) return null;
  const labelFor = (item) => question.options?.find((option) => option.value === item)?.label || item;
  return { id: question.id, label: question.summaryLabel || question.title,
    text: Array.isArray(value) ? value.map(labelFor).join(", ") : labelFor(value) };
}

export function summarizeAnswers(questions, answers) {
  return questions.map((question) => summaryAnswer(question, answers[question.id])).filter(Boolean);
}

const OPTIONAL_FIELDS = {
  organisation: "organisation", job_title: "jobTitle", target_role: "targetRole",
  expertise: "expertise", experience: "experience", location: "location", portfolio: "portfolio",
  preferred_contact: "preferredContact", message: "message",
};

export function buildInquiryPayload({ form, pathId, answers }) {
  const optional = Object.fromEntries(Object.entries(OPTIONAL_FIELDS)
    .map(([key, field]) => [key, form[field] || undefined]));
  return { ...optional, path: pathId, name: form.name, email: form.email,
    phone: `${form.phoneDial}${form.phone}`, consent: form.consent,
    escalate: pathId === "employer" && answers.need === "unsure", answers };
}